<template>
  <div class="partner d-flex align-center justify-center">
    <div class="partner-content d-flex f-column align-center justify-center">
      <h3>合作伙伴</h3>
      <p>
        长期深度合作伙伴，我们正在和公司产品一起推动中国生猪事业数据化、农产品溯源品牌化发展
      </p>
      <div class="list d-flex">
        <p
          style="width: 100%;margin-bottom: 0.3rem;border-left: 2px solid #353ADA;padding-left: 0.15rem;font-weight: 700;color: #666666;">
          政府、学校</p>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_01.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_02.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_03.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_04.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_05.png')"></el-image>
        </div>

	</div>
      <div class="list d-flex">
        <p
          style="width: 100%;margin-bottom: 0.3rem;border-left: 2px solid #353ADA;padding-left: 0.15rem;font-weight: 700;color: #666666;">
          农业、食品、畜牧业</p>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_06.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_07.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_08.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_09.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_10.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_11.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_12.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_13.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_14.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_15.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_16.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_17.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_18.png')"></el-image>
        </div>

	</div>
      <div class="list d-flex">
        <p
          style="width: 100%;margin-bottom: 0.3rem;border-left: 2px solid #353ADA;padding-left: 0.15rem;font-weight: 700;color: #666666;">
          通信</p>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_19.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_20.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_21.png')"></el-image>
        </div>

	</div>
      <div class="list d-flex">
        <p
          style="width: 100%;margin-bottom: 0.3rem;border-left: 2px solid #353ADA;padding-left: 0.15rem;font-weight: 700;color: #666666;">
          科技</p>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_22.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_23.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_24.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_25.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_26.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_27.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_28.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_29.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_30.png')"></el-image>
        </div>
        <div class="item d-flex align-center justify-center">
          <el-image class="image" :src="require('@/assets/images/about_logo_31.png')"></el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {}
</script>

<style lang="scss" scoped>
  .partner {
    padding-top: 1.25rem;

    &-content {
      h3 {
        font-size: 0.45rem;
        padding-bottom: 0.375rem;
      }

      p {
        font-size: 0.2rem;
        color: #666;
        margin-bottom: 0.825rem;
      }

      .list {
        width: 15rem;
        flex-wrap: wrap;

        .item {
          float: left;
          width: 2.8rem;
          height: 1.25rem;
          background-color: #f9fafe;
          margin-right: 0.25rem;
          margin-bottom: 0.25rem;

          &:nth-of-type(5n + 5) {
            margin-right: 0;
          }

          .image {
            display: block;
            width: 2.8rem;
            height: 1.25rem;
          }
        }
      }
    }
  }
</style>
